import { Helmet } from "react-helmet";
import RandingStyle4 from "../../randing/RandingStyle4";
import RandingStyle24 from "../../randing/RandingStyle24";

function Randing284({ urlCode, urlCodeSettingId, apiUrl }) {
  return (
    <>
      <Helmet>
        {/* Google Tag Manager [HEAD] */}
        <script>
          {`
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-PLTBRFG5');
          `}
        </script>
      </Helmet>
      {/* Google Tag Manager [BODY] */}
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-PLTBRFG5"
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
          title="gtm"
        ></iframe>
      </noscript>
      <RandingStyle24
        urlCode={urlCode}
        urlCodeSettingId={urlCodeSettingId}
        img1Path={`${process.env.REACT_APP_CDN_BASE}/images/284/1.png`}
        img2Path={`${process.env.REACT_APP_CDN_BASE}/images/284/2.png`}
        img3Path={`${process.env.REACT_APP_CDN_BASE}/images/284/3.png`}
        img4Path={`${process.env.REACT_APP_CDN_BASE}/images/284/4.png`}
        img5Path={`${process.env.REACT_APP_CDN_BASE}/images/284/5.png`}
        postBTN={`${process.env.REACT_APP_CDN_BASE}/images/284/postBTN.gif`}
        formFieldColor="white"
        privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
        benefitInfoPosition="bottom"
        companyName="본원"
        totalStep={1}
        apiUrl={apiUrl}
      />
    </>
  );
}

export default Randing284;
